import { useEffect } from "react";

const useOverflowControl = showModal => {
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showModal]);
};

export default useOverflowControl;
